module.exports = __webpack_public_path__ + "img/img-2.25942291.webp";